import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33de318e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ms-auto" })
], -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  id: "list-card",
  class: "__samplingPoints"
}
const _hoisted_5 = { class: "d-flex flex-row justify-content-between align-items-start" }
const _hoisted_6 = { class: "samplingPoint left text-truncate" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-ellipsis-v fas" }, null, -1))
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "__sampling-point-image",
  src: "/img/not_found.jpg",
  alt: "Not Image"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "search-button" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-search fas" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_NoDataComponent = _resolveComponent("NoDataComponent")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_sampling_point_image_component = _resolveComponent("sampling-point-image-component")!
  const _component_sampling_point_search_form_component = _resolveComponent("sampling-point-search-form-component")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { class: "header" }, {
      content: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t("title.samplingPointList")), 1)
      ]),
      _: 1
    }),
    (_ctx.samplingPoints.length === 0)
      ? (_openBlock(), _createBlock(_component_NoDataComponent, {
          key: 0,
          message: 'No hay puntos de monitorización disponibles todavía',
          subMessage: '¡Contáctanos para empezar a monitorizar tus ubicaciones!'
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.samplingPoints, (samplingPoint) => {
              return (_openBlock(), _createBlock(_component_el_card, {
                class: "__samplingPoint",
                key: samplingPoint.id
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("a", {
                          href: _ctx.$router.resolve(_ctx.generateRoute(samplingPoint)).href,
                          class: "samplingPoint left text-truncate"
                        }, _toDisplayString(_ctx.isAppDemo ? samplingPoint.id : samplingPoint.name), 9, _hoisted_7)
                      ]),
                      (_ctx.showButton)
                        ? (_openBlock(), _createBlock(_component_el_dropdown, {
                            key: 0,
                            class: "dropdown-wrapper"
                          }, {
                            dropdown: _withCtx(() => [
                              _createVNode(_component_el_dropdown_menu, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_dropdown_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        text: "",
                                        onClick: ($event: any) => (_ctx.checkVisualLevel(samplingPoint))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("menu.checkLevel")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, { circle: "" }, {
                                default: _withCtx(() => [
                                  _hoisted_8
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    (samplingPoint.lastImage)
                      ? (_openBlock(), _createBlock(_component_sampling_point_image_component, {
                          key: 0,
                          images: [
              {
                ...samplingPoint?.lastImage,
                ...{ title: _ctx.isAppDemo ? `${samplingPoint.id}` : samplingPoint.name },
              },
            ]
                        }, null, 8, ["images"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ])),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_el_popover, {
        placement: "bottom",
        width: 500,
        trigger: "click",
        onShow: _cache[0] || (_cache[0] = ($event: any) => (_ctx.samplingPointSearchForm ? _ctx.samplingPointSearchForm.focus() : null))
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_button, {
            class: "btn",
            type: "primary",
            size: "large",
            circle: ""
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_sampling_point_search_form_component, {
            onSearch: _ctx.doSearch,
            values: _ctx.search,
            ref: "samplingPointSearchForm"
          }, null, 8, ["onSearch", "values"])
        ]),
        _: 1
      })
    ])
  ], 64))
}